"use strict";

Shopify.theme.jsFeaturedBrandsSlider = {
  init: function init($section) {
    var $featuredBrandsSliderEl = $section.find('.js-featured-brands');
    var $prevButton = $section.find('.featured-brands__nav--prev');
    var $nextButton = $section.find('.featured-brands__nav--next');
    var $featuredBrandsSlider = $featuredBrandsSliderEl.flickity({
      wrapAround: true,
      draggable: true,
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: true,
      cellAlign: 'left',
      contain: true,
      initialIndex: 0,
      on: {
        ready: function ready() {
          setTimeout(function () {
            $featuredBrandsSlider.flickity('resize');
          }, 500);
        }
      }
    });
    // Change slide on nav button click
    $prevButton.on('click', function () {
        $featuredBrandsSlider.flickity('previous');
    });
    // Change slide on nav button click
    $nextButton.on('click', function () {
        $featuredBrandsSlider.flickity('next');
    });
  },
  blockSelect: function blockSelect($section, blockId) {
    var $slider = $section.find('.js-featured-brand');
    var $sliderIndex = $('#shopify-section-' + blockId).data('data-slide-index');
    $slider.flickity('select', $sliderIndex, true, true);
  },
  unload: function unload($section) {
    var $slider = $section.find('.js-featured-brands');
    $slider.flickity('destroy');
    $('.featured-brands__nav--prev').off();
    $('.featured-brands__nav--next').off();
  }
};